export default __webpack_public_path__ + "static/media/broadcast.24bcd198.svg";